<template>
  <div class='body-box marginBox'>
    <el-row class='plan'>
      <el-col :span='24'>
        <el-tabs v-model='queryInfo.status' @tab-click='btnStatus'>
          <el-tab-pane label='待审核' name='WAIT_APPROVAL'></el-tab-pane>
          <el-tab-pane label='审核通过' name='APPROVED'></el-tab-pane>
          <el-tab-pane label='审核拒绝' name='REJECT'></el-tab-pane>
          <el-tab-pane label='全部' name='ALL'></el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span='24'>
        <el-col :span="19">
          <el-button icon="el-icon-plus" @click="addGame">新增</el-button>
          <el-button @click="() => {$refs['formConfig'].open('game', '比赛设置')}">创建比赛设置</el-button>
          <el-button @click="() => {$refs['formConfig'].open('apply', '报名设置')}">报名设置</el-button>
        </el-col>
        <el-col :span="5">
          <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
        </el-col>
      </el-col>

    </el-row>

    <el-table :height="'calc(100% - 120px)'" :data='orderList' class='button-box'>
      <el-table-column label='比赛球场' prop='courtName' />
      <el-table-column label='比赛名称' prop='name' />
      <el-table-column label='比赛日期' prop='raceDate'>
        <template slot-scope='scope'>
          {{ scope.row.raceDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label='开始时间' prop='raceTime'></el-table-column>
      <el-table-column label='报名截止日期' prop='applyEndDate'>
        <template slot-scope='scope'>
          {{ scope.row.applyEndDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label='组数' prop='num'></el-table-column>
      <el-table-column label='开球方式' prop='kickOffMode'>
        <template slot-scope='scope'>
          {{ scope.row.kickOffMode | kickOffMode }}
        </template>
      </el-table-column>
      <el-table-column label='打球費' prop='fee'></el-table-column>
      <el-table-column label='参加费' prop='joinFee'></el-table-column>
      <el-table-column label='状态' prop='enumStatus'>
        <template slot-scope='scope'>
          {{ scope.row.enumStatus | raceRaiseStatus }}
        </template>
      </el-table-column>
      <el-table-column label='发起人姓名' prop='userName'></el-table-column>
      <el-table-column label='发起人电话' prop='tel'></el-table-column>
      <el-table-column label='发起人邮箱' prop='email'></el-table-column>
      <el-table-column label='排序' prop='sort'></el-table-column>
      <el-table-column label='操作' min-width='100' fixed='right'>
        <template slot-scope='scope'>
          <el-popover placement='right' trigger='click'>
            <div class='foldBtnBox'>

              <div>
                <el-button @click='updateGameOrder(scope.row)'>修改</el-button>
              </div>
              <div>
                <el-button @click='qrcode(scope.row.id)'>二维码</el-button>
              </div>
              <div>
                <el-button @click='openApplyDialog(scope.row.id)'>查看报名人信息</el-button>
              </div>
              <div>
                <el-button @click='openOrder(scope.row)'>修改状态</el-button>
              </div>
              <div>
                <el-button @click='removeById(scope.row.id)'>删除</el-button>
              </div>
            </div>
            <el-button slot='reference'>更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <div class='fixedBox'>
      <pagination ref='page' :query-param.sync='queryInfo' @pagination='getOrderList'></pagination>
    </div>


    <!--查看打球人-->
    <el-dialog title='报名信息' :visible.sync='dialogVisible' width='80%'>
      <el-table :data='applyList' class='button-box'>
        <el-table-column label='报名人' prop='userName' />
        <el-table-column label='报名电话' prop='tel' />
        <el-table-column label='报名E-Mail' prop='email' />
        <el-table-column label='报名人' prop='userName' />
        <el-table-column label='预约人数' prop='personNum'></el-table-column>
        <el-table-column label='预约分组'>
          <template slot-scope='scope'>
            <el-button @click='lookDiamond(scope.row.groupPerson)'>查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label='巴士' prop='bus'>
          <template slot-scope='scope'>
            {{ scope.row.bus | formatYESNo }}
          </template>
        </el-table-column>
        <el-table-column label='宴会' prop='food'>
          <template slot-scope='scope'>
            {{ scope.row.food | formatYESNo }}
          </template>
        </el-table-column>

        <el-table-column label='協賛品提供' prop='provision'>
          <template slot-scope='scope'>
            {{ scope.row.provision | formatYESNo }}
          </template>
        </el-table-column>
        <el-table-column label='球场会员' prop='vip'>
          <template slot-scope='scope'>
            {{ scope.row.vip | formatYESNo }}
          </template>
        </el-table-column>
        <el-table-column label='成绩表' prop='gradeTable'>
          <template slot-scope='scope'>
            {{ scope.row.gradeTable | formatYESNo }}
          </template>
        </el-table-column>
        <el-table-column label='备注' prop='brief'></el-table-column>

        <el-table-column label='操作' min-width='100' fixed='right'>
          <template slot-scope='scope'>
            <el-popover placement='right' trigger='click'>
              <div class='foldBtnBox'>
                <div>
                  <el-button @click='updateApply(scope.row)'>修改</el-button>
                </div>
                <div>
                  <el-button @click='removeApplyById(scope.row.id)'>删除</el-button>
                </div>
              </div>
              <el-button slot='reference'>更多操作</el-button>
            </el-popover>
          </template>
        </el-table-column>


      </el-table>
    </el-dialog>
    <!--查看打球人-->
    <el-dialog title='查看打球人' :visible.sync='userDialogVisible' width='30%'>
      <div v-for='(item, index) in valList' :key='index' class='plo'>
        <span>第{{ item.type }}组  :  </span>
        <span v-for='(item2, i) in item.data' :key='item2.id'><span v-if='i !== 0'> , </span> {{ item2.name }} </span>
      </div>
    </el-dialog>
    <!--获取用户信息-->
    <!--修改状态-->
    <modify-order @refresh-list='handleQuery' ref='modifyOrder'></modify-order>
    <el-dialog
      title="二维码"
      :visible.sync="qrcodeDialogVisible"
      append-to-body
      custom-class="pay-addr-dialog"
      width="40%">
      <div style="display: flex; justify-content: center;">
        <img :src="`/business/qrcode/getQRCode?content=${raceId}`" />
      </div>

    </el-dialog>
    <form-config ref='formConfig'></form-config>
  </div>
</template>

<script>
import { deleteRacesById, getRacesList, getApplyList, deleteApplyById } from '@/api/race/raceRaise'
import Pagination from '@/components/common/Pagination/index'
import ModifyOrder from '@/components/common/modifyOrder/index'
import SearchInput from '@/components/common/searchInput/searchInput'
import FormConfig from '@/components/common/formConfig/FormConfig.vue'
export default {
  components: { SearchInput, Pagination, ModifyOrder, FormConfig },
  data() {
    return {
      orderList: [],
      applyList: [],
      dialogVisible: false,
      userDialogVisible: false,
      qrcodeDialogVisible: false,
      playBallTime: {},
      valList: [],
      queryInfo: {
        status: 'WAIT_APPROVAL'
      },
      raceId: ''
    }
  },
  created() {

  },
  mounted() {
    this.handleQuery()
  },
  methods: {

    btnStatus(val) {
      this.queryInfo.status = val.name === 'ALL' ? '' : val.name
      this.handleQuery()
    },
    qrcode(raceId) {
      this.raceId = raceId
      this.qrcodeDialogVisible = true
    },

    removeById(id) {
      this.$confirm('是否删除,此操作不可逆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRacesById(id).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功')
            this.handleQuery()
          }
        })
      }).catch(() => {
      })

    },
    removeApplyById(id) {
      this.$confirm('是否删除,此操作不可逆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteApplyById(id).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功')
            this.getApplyList()
          }
        })
      }).catch(() => {
      })
    },

    //修改状态
    openOrder(row) {
      this.$refs.modifyOrder.editDialog(row, 'RACE_RAISE')
    },

    //获取列表
    getOrderList(page, cb) {
      console.log('page', page)
      getRacesList(page).then(res => {
        this.orderList = cb(res)
      })
    },
    getApplyList() {
      getApplyList(this.raceId).then(res => {
        this.applyList = res.data
        this.applyList.forEach(f => {
          if (f.groupPerson) {
            f.groupPerson = JSON.parse(f.groupPerson)
            let personNum = 0
            if (f.groupPerson.length > 0) {
              for (let item of f.groupPerson) {
                personNum += item.data.length
              }
            }
            f.personNum = personNum

          } else {
            f.personNum = 0
          }

        })
      })
    },
    openApplyDialog(raceId) {
      this.raceId = raceId
      this.getApplyList()
      this.dialogVisible = true
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },
    //修改比赛页面
    updateGameOrder(row) {
      localStorage.setItem(row.id, JSON.stringify(row))
      this.$router.push({
        path: '/updateRaceRaise',
        query: {
          id: row.id
        }
      })
    },
    //修改比赛报名
    updateApply(row) {
      localStorage.setItem(row.id, JSON.stringify(row))
      this.$router.push({
        path: '/updateRaceApply',
        query: {
          id: row.id
        }
      })
    },
    //查看打球人
    lookDiamond(val) {
      this.valList = val
      this.userDialogVisible = true
    },
    addGame() {
      this.$router.push({
        path: '/updateRaceRaise'
      })
    }

  }
}
</script>

<style scoped>

</style>
